export default "__VITE_ASSET__5815d29a__"